import { instance as axios, setJwtToken } from "../../config/axiosInstance";

const claudeRequestConfig = () => ({
  ...setJwtToken(),
  // Anthropic auth/model errors must not clear the admin session.
  skipAuthLogout: true,
});

export const fetchClaudeStatusApi = async () => {
  return axios.get("/admin/claude-analysis/status", claudeRequestConfig());
};

export const fetchClaudeCatalogApi = async () => {
  return axios.get("/admin/claude-analysis/catalog", claudeRequestConfig());
};

export const fetchClaudeSnapshotApi = async ({ days, section, subsection }) => {
  const params = new URLSearchParams({
    days: String(days),
    section: section || "overview",
    subsection: subsection || "ops-health",
  }).toString();
  return axios.get(`/admin/claude-analysis/snapshot?${params}`, claudeRequestConfig());
};

export const askClaudeAnalysisApi = async (payload) => {
  return axios.post("/admin/claude-analysis/ask", payload, claudeRequestConfig());
};

export const claudeOpsChatApi = async (payload) => {
  return axios.post("/admin/claude-analysis/chat", payload, claudeRequestConfig());
};

export const confirmClaudeActionApi = async (payload) => {
  return axios.post("/admin/claude-analysis/confirm-action", payload, claudeRequestConfig());
};

export const cancelClaudeActionApi = async (payload) => {
  return axios.post("/admin/claude-analysis/cancel-action", payload, claudeRequestConfig());
};

export const exportClaudeAudienceApi = async (payload) => {
  return axios.post("/admin/claude-analysis/export-audience", payload, {
    ...claudeRequestConfig(),
    responseType: "blob",
  });
};

export const listClaudeChatsApi = async () => {
  return axios.get("/admin/claude-analysis/chats", claudeRequestConfig());
};

export const createClaudeChatApi = async () => {
  return axios.post("/admin/claude-analysis/chats", {}, claudeRequestConfig());
};

export const getClaudeChatApi = async (id) => {
  return axios.get(`/admin/claude-analysis/chats/${id}`, claudeRequestConfig());
};

export const deleteClaudeChatApi = async (id) => {
  return axios.delete(`/admin/claude-analysis/chats/${id}`, claudeRequestConfig());
};
